import useBSSLogger from "../hooks/useBSSLogger";

const {logger} = useBSSLogger();

const __t = (chiave, parametri = [], messaggi = spedizioniweb2?.messaggi ?? []) => {

    logger.finer("cerco la traduzione per la chiave", chiave)

    let esitotrovata = true;

    const segmenti = chiave.split(".");
    let messaggio = messaggi[chiave] ?? chiave;


    if(Array.isArray(segmenti) && segmenti.length > 1){
        messaggio = segmenti.reduce((obj, seg, indice) => {

            esitotrovata = esitotrovata && ((obj?.[seg] ?? false) !== false)

            return obj?.[seg] ?? chiave
        }, messaggi)

    } else{
        if((messaggi[chiave] ?? null) === null){
            esitotrovata = false;
        }
    }

    if(!esitotrovata){
        logger.finer("chiave di traduzione non trovata", chiave);
    }


    let messaggiofinale = messaggio;
    if(Array.isArray(parametri) && parametri.length >= 1){
        messaggiofinale = parametri.reduce((msg, parametro, indice) => msg.replace(`%${indice+1}\$s`, parametro), messaggio);
    }

    return messaggiofinale;
}

const getBrowserLang = () => {
    const lang = (navigator.languages !== undefined) ? 
        navigator.languages[0]
        : navigator.language
    
    return lang;
}

export default __t;
export {getBrowserLang}